import { render } from "./ResetPassword.vue?vue&type=template&id=622b6b71&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=622b6b71&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-622b6b71"

export default script